import { supabase } from './supabase';

export interface SensorHistorikkRad {
  registrert_at: string | null;
  vann_avstand_mm: number | null;
  /** Høyre skuff i 2.0 stor (laser 2). */
  vann2_avstand_mm?: number | null;
  jord1: number | null;
  jord2: number | null;
  jord3: number | null;
  jord4: number | null;
  temperatur?: number | null;
  luftfuktighet?: number | null;
}

// Kolonnen til høyre skuff kom 20.10.2026. Før SQL-en er kjørt, hentes resten uten den.
let medVann2 = true;
const manglerVann2 = (e: { code?: string; message?: string }) =>
  e.code === '42703' || /vann2_avstand_mm/.test(e.message ?? '');

function kolonner(medHoyre: boolean) {
  const q = supabase.from('potte_sensor_data');
  return medHoyre
    ? q.select('registrert_at, vann_avstand_mm, vann2_avstand_mm, jord1, jord2, jord3, jord4, temperatur, luftfuktighet')
    : q.select('registrert_at, vann_avstand_mm, jord1, jord2, jord3, jord4, temperatur, luftfuktighet');
}

/** Sider under API-grensen: sju døgn ved fem minutter er over 2000 rader. */
export async function hentSensorHistorikk(potteId: string, dager: number, naa = Date.now()): Promise<SensorHistorikkRad[]> {
  const fra = new Date(naa - dager * 86_400_000).toISOString();
  const til = new Date(naa).toISOString();
  const rader: SensorHistorikkRad[] = [];
  const sideStorrelse = 500;
  for (let start = 0; ; start += sideStorrelse) {
    const { data, error } = await kolonner(medVann2)
      .eq('potte_id', potteId).gte('registrert_at', fra).lte('registrert_at', til)
      .order('registrert_at', { ascending: true }).order('id', { ascending: true })
      .range(start, start + sideStorrelse - 1);
    if (error && medVann2 && manglerVann2(error)) {
      medVann2 = false;
      start -= sideStorrelse; // samme side på nytt, uten kolonnen
      continue;
    }
    if (error) throw error;
    rader.push(...(data ?? []));
    if (!data || data.length < sideStorrelse) return rader;
  }
}
